import { getPropagatedHeaders } from './getPropagatedHeaders';

function toRecord(init?: HeadersInit): Record<string, string> {
    if (!init) {
        return {};
    }
    if (init instanceof Headers) {
        return Object.fromEntries(init.entries());
    }
    if (Array.isArray(init)) {
        return Object.fromEntries(init);
    }
    return { ...init };
}

/**
 * Merges the configured propagation headers (from the incoming request) into an
 * existing `fetch` `HeadersInit` for service clients that use `fetch` rather
 * than axios. Existing headers always win, so propagation never clobbers a
 * value the caller set explicitly.
 */
export async function withPropagatedHeaders(existing?: HeadersInit): Promise<Record<string, string>> {
    const propagated = await getPropagatedHeaders();
    // Propagated first so caller-provided headers take precedence on conflict.
    return { ...propagated, ...toRecord(existing) };
}
